import { getApis } from "library/Apis";
import { Dispatch } from "redux";
import api from "services/api";
import { toRequest } from "utils/RequestUtils";
import { Adendo, CallbackError, CallbackSuccess, Documento, ModalUploadValoresCampos, ModelosDocumentos } from "./__types";
import { AxiosError, AxiosResponse } from "axios";
import SnackbarUtils from "utils/SnackbarUtils";
import languageValues from "utils/LanguageUtils";
import { ConsultaPesquisaUsuario } from "pages/Contratos/components/ModalPesquisa/__typex";
import { TipoFluxoDescricao } from "models/contratos";

export const NEXT_STEP_CONTRATOS = "NEXT_STEP_CONTRATOS";
export const PREVIOUS_STEP_CONTRATOS = "PREVIOUS_STEP_CONTRATOS";
export const SET_CURRENT_CONTRATO_STEP = "SET_CURRENT_CONTRATO_STEP";
export const CLEARED_COOPERATIVA_BY_COD_ACTION = 'CLEARED_COOPERATIVA_BY_COD_ACTION'

export const ADD_SINGLE_FILE_CONTRACT_ACTION = 'ADD_SINGLE_FILE_CONTRACT_ACTION';
export const ADD_MULTIPLES_FILES_CONTRACT_ACTION = 'ADD_MULTIPLES_FILES_CONTRACT_ACTION';
export const ADD_SELECTED_OPTION_ACTION = 'ADD_SELECTED_OPTION_ACTION';
export const CLEAR_UPLOADED_FILE_ACTION = 'CLEAR_UPLOADED_FILE_ACTION';
export const CLEAR_SELECTED_OPTION_ACTION = 'CLEAR_SELECTED_OPTION_ACTION';

export const LOADING_CONTRATO_ARQUIVOS_AUXILIARES_ACTION = 'LOADING_CONTRATO_ARQUIVOS_AUXILIARES_ACTION'
export const LOADED_CONTRATO_ARQUIVOS_AUXILIARES_ACTION = 'LOADED_CONTRATO_ARQUIVOS_AUXILIARES_ACTION'
export const LOADED_ADENDO_ACTION = 'LOADED_ADENDO_ACTION'
export const LOADED_COOPERATIVA_BY_COD_ACTION = 'LOADED_COOPERATIVA_BY_COD_ACTION';
export const LOADING_COOPERATIVA_BY_COD_ACTION = 'LOADING_COOPERATIVA_BY_COD_ACTION';
export const LIST_ADENDOS_ACTION = 'LIST_ADENDOS_ACTION';
export const SET_FILTERS_DOCUMENTO = 'SET_FILTERS_DOCUMENTO';
export const RESET_FILTERS_DOCUMENTO = 'RESET_FILTERS_DOCUMENTO';
export const RECOVER_FILTERS_DOCUMENTO = 'RECOVER_FILTERS_DOCUMENTO'
export const RECOVER_FILTERS_DOCUMENTO_ENTE_PUBLICO = 'RECOVER_FILTERS_DOCUMENTO_ENTE_PUBLICO'
export const RECOVER_FILTERS_DOCUMENTO_ENTE_PRIVADO = 'RECOVER_FILTERS_DOCUMENTO_ENTE_PRIVADO'
export const CLEAR_CONTRATO_ADENDOS = 'CLEAR_CONTRATO_ADENDOS';
export const LOADED_CONTRATO_STATUS_CONTRATO_GLOBAL =
  'LOADED_CONTRATO_STATUS_CONTRATO_GLOBAL';
export const CLEAR_CONTRATO_STATUS_GLOBAL = 'CLEAR_CONTRATO_STATUS_GLOBAL';
export const CLEAR_COD_COOP_ACTION = 'CLEAR_COD_COOP_ACTION';
export const REMOVE_SINGLE_FILE_CONTRACT_ACTION = 'REMOVE_SINGLE_FILE_CONTRACT_ACTION';
export const REMOVE_MULTIPLES_FILES_CONTRACT_ACTION = 'REMOVE_MULTIPLES_FILES_CONTRACT_ACTION';
export const REMOVE_MULTIPLES_ALL_FILES_CONTRACT_ACTION = 'REMOVE_MULTIPLES_ALL_FILES_CONTRACT_ACTION';
export const SET_DOCUMENTOS_CONTRACT = 'SET_DOCUMENTOS_CONTRACT';
export const OPEN_MODAL_UPLOAD_DOCUMENTOS = 'OPEN_MODAL_UPLOAD_DOCUMENTOS';
export const CLOSE_MODAL_UPLOAD_DOCUMENTOS = 'CLOSE_MODAL_UPLOAD_DOCUMENTOS';
export const OPEN_MODAL_UPLOAD_DOCUMENTOS_COM_PARAMETROS = 'OPEN_MODAL_UPLOAD_DOCUMENTOS_COM_PARAMETROS';

export const closeModalUploadDocumentos = () => ({
  type: CLOSE_MODAL_UPLOAD_DOCUMENTOS,
});

export const abrirModalUploadDocumentos = () => ({
  type: OPEN_MODAL_UPLOAD_DOCUMENTOS,
});

export const abrirModalUploadDocumentosComParametros = (valoresCampos: ModalUploadValoresCampos) => ({
  type: OPEN_MODAL_UPLOAD_DOCUMENTOS_COM_PARAMETROS,
  payload: valoresCampos,
});

export const setDocumentos = (documentos: Documento[]) => ({
  type: SET_DOCUMENTOS_CONTRACT,
  payload: documentos,
});

export const removeSingleFile = (file: File) => ({
  type: REMOVE_SINGLE_FILE_CONTRACT_ACTION,
  payload: file,
});

export const addSingleFile = (file: File | null) => ({
  type: ADD_SINGLE_FILE_CONTRACT_ACTION,
  payload: file,
});

export const adicionaMultiplosArquivos = (files: File[]) => ({
  type: ADD_MULTIPLES_FILES_CONTRACT_ACTION,
  payload: files,
});

export const removeArquivo = (file: File) => ({
  type: REMOVE_MULTIPLES_FILES_CONTRACT_ACTION,
  payload: file,
});

export const removeTodosArquivos = () => ({
  type: REMOVE_MULTIPLES_ALL_FILES_CONTRACT_ACTION,
});

export const addSelectedOption = (option: number | null) => ({
  type: ADD_SELECTED_OPTION_ACTION,
  payload: option,
});

export const setFiltersDocumento = <T>(filters: T) => ({
  type: SET_FILTERS_DOCUMENTO,
  payload: filters,
});

export const clearContratoAdendos = () => {
  return {
    type: CLEAR_CONTRATO_ADENDOS,
  };
};

export const listAdendos = (adendos: Adendo[]) => ({
  type: LIST_ADENDOS_ACTION,
  payload: { adendos },
});

export const recoverFiltersDocumento = () => {
  const savedFilters = localStorage.getItem('documentoFiltersAssessor');
  if (savedFilters) {
    return {
      type: RECOVER_FILTERS_DOCUMENTO,
      payload: JSON.parse(savedFilters),
    };
  }
  return { type: RECOVER_FILTERS_DOCUMENTO, payload: {} };
};

export const recoverFiltersDocumentoEntePublico = () => {
  const savedFilters = localStorage.getItem('documentoFiltersEntePublico');
  if (savedFilters) {
    return {
      type: RECOVER_FILTERS_DOCUMENTO_ENTE_PUBLICO,
      payload: JSON.parse(savedFilters),
    };
  }
  return { type: RECOVER_FILTERS_DOCUMENTO_ENTE_PUBLICO, payload: {} };
};

export const recoverFiltersDocumentoEntePrivado = () => {
  const savedFilters = localStorage.getItem('documentoFiltersEntePrivado');
  if (savedFilters) {
    return {
      type: RECOVER_FILTERS_DOCUMENTO_ENTE_PRIVADO,
      payload: JSON.parse(savedFilters),
    };
  }
  return { type: RECOVER_FILTERS_DOCUMENTO_ENTE_PRIVADO, payload: {} };
};

export const resetFiltersDocumento = () => {
  localStorage.removeItem('documentoFiltersAssessor');
  localStorage.removeItem('documentoFiltersEntePublico');
  localStorage.removeItem('documentoFiltersEntePrivado');
  return {
    type: RESET_FILTERS_DOCUMENTO,
  };
};

export const clearUploadedFile = () => ({
  type: CLEAR_UPLOADED_FILE_ACTION,
});

export const clearUploadSelectedOption = () => ({
  type: CLEAR_SELECTED_OPTION_ACTION,
});

export const setCurrentContratoStep = (step: number) => ({
  type: SET_CURRENT_CONTRATO_STEP,
  payload: step,
});
export const contratosNextStep = () => ({
  type: NEXT_STEP_CONTRATOS
});
export const contratosPreviousStep = () => ({
  type: PREVIOUS_STEP_CONTRATOS
});

export const clearCooperativaByCod = () => ({
  type: CLEARED_COOPERATIVA_BY_COD_ACTION,
  payload: null,
});

export const clearContratoStatusGlobal = () => {
  return {
    type: CLEAR_CONTRATO_STATUS_GLOBAL,
  };
};

const getEndpoint = (version: number) => {
  return getApis().apis.contrato + 'v' + version;
};

export const getModelosArquivosAuxiliares = (
  tipoFluxo: string,
  tipoContrato: number | null,
  programa: number[],
  callbackSuccess?: (response: { data: ModelosDocumentos[] }) => void,
  callbackError?: (error: AxiosError) => void
) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: LOADING_CONTRATO_ARQUIVOS_AUXILIARES_ACTION,
      payload: true,
    });
    toRequest(
      api.get,
      [
        `${getEndpoint(
          1
        )}/documento/auxiliar?tipoFluxo=${tipoFluxo}&tipoContrato=${tipoContrato}&programasEducacionais=${programa.join(',')}`,
      ],
      'contratoDocumentosAuxiliares'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_CONTRATO_ARQUIVOS_AUXILIARES_ACTION,
          payload: resp.data || [],
        });
        dispatch({
          type: LOADING_CONTRATO_ARQUIVOS_AUXILIARES_ACTION,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        dispatch({
          type: LOADING_CONTRATO_ARQUIVOS_AUXILIARES_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadCooperativaByCod = (
  codCoop: string,
  callbackSuccess?: () => void,
  callbackError?: (error: AxiosError) => void
) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: LOADING_COOPERATIVA_BY_COD_ACTION,
      payload: true,
    });
    toRequest(
      api.get,
      [`${getEndpoint(1)}/cooperativa/${codCoop}`],
      'cooperativaByCod'
    ).then(
      (resp) => {
        dispatch({
          type: LOADING_COOPERATIVA_BY_COD_ACTION,
          payload: false,
        });
        dispatch({
          type: LOADED_COOPERATIVA_BY_COD_ACTION,
          payload: {
            ...resp.data,
          },
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        dispatch({
          type: LOADING_COOPERATIVA_BY_COD_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadContratoAdendos = (id: number | null) => {
  return async (dispatch: Dispatch) => {
    try {
      const adendosResponse = await toRequest(api.get, [
        `${getEndpoint(1)}/contrato/listar-adendos/${id}`,
      ]);
      dispatch({
        type: LOADED_ADENDO_ACTION,
        payload: adendosResponse.data,
      });
      dispatch({
        type: LOADED_CONTRATO_STATUS_CONTRATO_GLOBAL,
        payload: adendosResponse.data.flgStatus,
      });
      dispatch({
        type: LIST_ADENDOS_ACTION,
        payload: { adendos: adendosResponse.data.adendos || [] },
      });
    } catch (error) {
      SnackbarUtils.enqueueSnackbar({
        message:
          error ||
          languageValues.toasts.error
            .carregarContratosAssessoresDescentralizadosAdendos,
        options: {
          variant: 'error',
        },
      });
    }
  };
};

export const contratoAlteraStatus = (
  id: number | null,
  versaoContrato: number,
  callbackSuccess: (resp: AxiosResponse) => void,
  callbackError: (message: string) => void
) => {
  return () => {
    toRequest(api.put, [
      `${getEndpoint(1)}/contrato/status/${id}/${versaoContrato}`,
    ]).then(
      (resp) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const deleteDocumentoContrato = (
  id: number,
  callbackSuccess?: (response: AxiosResponse) => void,
  callbackError?: (error: AxiosError) => void
) => {
  return async () => {
    await toRequest(api.delete, [
      `${getEndpoint(1)}/documento/contrato/${id}`,
    ]).then(
      (resp) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const deleteDocumentoAditivo = (
  id: number,
  callbackSuccess?: (response: AxiosResponse) => void,
  callbackError?: (error: AxiosError) => void
) => {
  return async () => {
    await toRequest(api.delete, [
      `${getEndpoint(1)}/documento/aditivo/${id}`,
    ]).then(
      (resp) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const deleteDocumentoDistrato = (
  id: number,
  callbackSuccess?: (response: AxiosResponse) => void,
  callbackError?: (error: AxiosError) => void
) => {
  return async () => {
    await toRequest(api.delete, [
      `${getEndpoint(1)}/documento/distrato/${id}`,
    ]).then(
      (resp) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const contratoUploadDocumento = (
  file: File,
  versaoContrato: string,
  id: number | null,
  urlPath: string,
  callbackSuccess: CallbackSuccess,
  callbackError: CallbackError
) => {
  return (dispatch: Dispatch) => {
    const baseUrl = `${getEndpoint(1)}/documento`;
    const url = urlPath ? `${baseUrl}/${urlPath}` : `${baseUrl}/${versaoContrato}/${id}`;
    const data = new FormData();
    data.append('file', file);

    toRequest(
      api.post,
      [
        url,
        data,
        {
          headers: {
            'content-type': 'multipart/form-data',
          },
        },
      ],
      'save'
    ).then(
      (resp: AxiosResponse) => {
        callbackSuccess(resp, file);
        dispatch({
          type: LOADED_ADENDO_ACTION,
          payload: data,
        });
      },
      (error: AxiosError) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const contratoUploadDocAssinado = (
  file: File,
  versaoContrato: string,
  id: number | null,
  callbackSuccess: CallbackSuccess,
  callbackError: CallbackError
) => {
  return contratoUploadDocumento(file, versaoContrato, id, '', callbackSuccess, callbackError);
};

export const contratoUploadDocPlanoTrabalho = (
  file: File,
  versaoContrato: string,
  id: number | null,
  callbackSuccess: CallbackSuccess,
  callbackError: CallbackError
) => {
  const urlPath = id ? `plano-trabalho/${versaoContrato}/${id}` : '';
  return contratoUploadDocumento(file, versaoContrato, id, urlPath, callbackSuccess, callbackError);
};

export const contratoUploadDocPlanoTrabalhoEDocAssinado = (
  file: File,
  versaoContrato: string,
  id: number | null,
  callbackSuccess: CallbackSuccess,
  callbackError: CallbackError
) => {
  const urlPath = id ? `${versaoContrato}/${id}?incluiPlanoTrabalho=true` : '';
  return contratoUploadDocumento(file, versaoContrato, id, urlPath, callbackSuccess, callbackError);
};

export const contratoUploadExtrato = (
  file: File,
  versaoContrato: string,
  id: number | null,
  callbackSuccess: CallbackSuccess,
  callbackError: CallbackError
) => {
  const urlPath = id ? `extrato/${versaoContrato}/${id}` : '';
  return contratoUploadDocumento(file, versaoContrato, id, urlPath, callbackSuccess, callbackError);
};

export const cadastroUploadDocumentos = (
  tipoFluxo: string,
  tipoContrato: number,
  programasEducacionais: number[],
  arquivos: File[]
) => {
  return async () => {
    const payload = new FormData();
    arquivos.forEach((file: File) => {
      payload.append('file', file);
    });

    const getTipoFluxoValue = (tipoFluxoParam: string) => {
      const tipoFluxoNumber = Number(tipoFluxoParam);
      if (tipoFluxoNumber === 1) {
        return TipoFluxoDescricao.CENTRALIZADO.toUpperCase();
      } else if (tipoFluxoNumber === 2) {
        return TipoFluxoDescricao.DESCENTRALIZADO.toUpperCase();
      } else {
        return '';
      }
    };

    const tipoFluxoValue = getTipoFluxoValue(tipoFluxo);
    const tiposProgramasValue = programasEducacionais.join(',');
    const url = `${getEndpoint(1)}/documento/auxiliar?tipoContrato=${tipoContrato}&tipoFluxo=${tipoFluxoValue}&tiposProgramas=${tiposProgramasValue}`;

    try {
      const response = await api.post(url, payload);
      if (response.status === 200) {
        SnackbarUtils.enqueueSnackbar({
          message: languageValues.toasts.success.saveUpload,
          options: {
            variant: 'success',
          },
        });
      }
    } catch (error: any) {
      if (error.response && error.response.status === 417) {
        SnackbarUtils.enqueueSnackbar({
          message: error.response.data.message,
          options: {
            variant: 'error',
          },
        });
      } else {
        SnackbarUtils.enqueueSnackbar({
          message: languageValues.toasts.error.erroTamanhoDeArquivo,
          options: {
            variant: 'error',
          },
        });
      }
    }
  };
};

export const getDocumentosAuxiliaresCategorizados = () => {
  return async (dispatch: Dispatch) => {
    try {
      const response = await api.get(`${getEndpoint(1)}/documento/auxiliar/categorizado`);
      if (response.status === 200) {
        dispatch(setDocumentos(response.data));
      }
    } catch (error) {
      SnackbarUtils.enqueueSnackbar({
        message: error || languageValues.toasts.error.carregarDocumentosAuxiliares,
        options: {
          variant: 'error',
        },
      });
    }
  };
};

export const deleteDocumentoAuxiliarCategorizado = (
  id: number,
  callbackSuccess?: (response: AxiosResponse) => void,
  callbackError?: (error: unknown) => void
) => {
  return async () => {
    try {
      const response = await toRequest(api.delete, [
        `${getEndpoint(1)}/documento/auxiliar/${id}`,
      ]);
      if (typeof callbackSuccess === 'function') {
        callbackSuccess(response);
      }
      return response;
    } catch (error) {
      if (typeof callbackError === 'function') {
        callbackError(error);
      }
      throw error;
    }
  };
};

export const downloadDocumentoById = (
  idDocumento: number | null | undefined,
  contentType: string,
  apiEndpoint: 'pdf' | 'auxiliar',
  callbackSuccess: (response: AxiosResponse) => void,
  callbackError: (error: AxiosError) => void
) => {
  return () => {
    toRequest(api.get, [
      `${getEndpoint(1)}/documento/${apiEndpoint}/${idDocumento}`,
      {
        responseType: 'arraybuffer',
        headers: {
          Accept: contentType,
          'Access-Control-Allow-Headers':
            'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With',
        },
      },
    ]).then(
      (resp: AxiosResponse) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error: AxiosError) => {
        if (typeof callbackError === 'function') {
          callbackError(error as AxiosError);
        }
      }
    );
  };
};

export const getPesquisaUsuario = (callbackSuccess: (response: ConsultaPesquisaUsuario) => void) => {
  return async () => {
    try {
      return await api.get(`${getEndpoint(1)}/pesquisa-usuario`)
        .then((res) => callbackSuccess(res.data));
    } catch (error) {
      SnackbarUtils.enqueueSnackbar({
        message: error || languageValues.toasts.error.carregarPesquisaUsuario,
        options: {
          variant: 'error',
        },
      });
    }
  };
};

export const postPerguntarDepois = (callbackSuccess: () => void, callbackError?: () => void) => {
  return async () => {
    try {
      return await api.post(`${getEndpoint(1)}/pesquisa-usuario/perguntar-depois`)
        .then(() => callbackSuccess());
    } catch (error) {
      SnackbarUtils.enqueueSnackbar({
        message: error || languageValues.toasts.error.salvarPesquisa,
        options: {
          variant: 'error',
        },
      });
      callbackError?.();
    }
  };
};

export const postConcluirPesquisa = (callbackSuccess: () => void, callbackError?: () => void) => {
  return async () => {
    try {
      return await api.post(`${getEndpoint(1)}/pesquisa-usuario/concluir`)
        .then(() => callbackSuccess());
    } catch (error) {
      SnackbarUtils.enqueueSnackbar({
        message: error || languageValues.toasts.error.salvarPesquisa,
        options: {
          variant: 'error',
        },
      });
      callbackError?.();
    }
  };
};
